import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { signup, resetSignup } from "../actions/authActions";

const Register = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory()

  const { loading } = useSelector((state) => state.userRegister);

  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [isEmailFromParams, setIsEmailFromParams] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const email = queryParams.get("email");

    if (email) {
      setForm((prevForm) => ({
        ...prevForm,
        email,
      }));
      setIsEmailFromParams(true);
    }
  }, [location.search]);

  useEffect(() => {
    return () => {
      dispatch(resetSignup());
    };
  }, [dispatch]);

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });
    if (errors[field]) {
      setErrors({
        ...errors,
        [field]: null,
      });
    }
  };

  const findFormErrors = () => {
    const {
      email,
      firstName,
      lastName,
      phone,
      password,
      confirmPassword,
    } = form;
    const newErrors = {};

    if (!email) newErrors.email = "Email is required";
    if (!firstName) newErrors.firstName = "First Name is required";
    if (!lastName) newErrors.lastName = "Last Name is required";
    if (!phone) newErrors.phone = "Phone Number is required";
    if (!password) newErrors.password = "Password is required";
    if (!confirmPassword) newErrors.confirmPassword = "Confirm Password is required";
    else if (confirmPassword !== password)
      newErrors.confirmPassword = "Passwords do not match";

    return newErrors;
  };

  const registerHandler = async(e) => {
    e.preventDefault();
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      const result = await dispatch(signup(form)); 
      if (result.success) {
        history.push("/"); // Redirect to home page on success
      }
    }
  };

  return (
    <div className="register-container">
      <ToastContainer />
      <h3>Create Account</h3>
      <form onSubmit={registerHandler}>
        <div className="form-row">
          <div className="col-md-4">
            <label htmlFor="firstName">First Name</label>
            <input
              type="text"
              className="form-control"
              id="firstName"
              name="firstName"
              placeholder="First Name"
              onChange={(e) => setField("firstName", e.target.value)}
            />
            {errors.firstName && (
              <span className="error">{errors.firstName}</span>
            )}
          </div>
          <div className="col-md-4">
            <label htmlFor="middleName">Middle Name</label>
            <input
              type="text"
              className="form-control"
              id="middleName"
              name="middleName"
              placeholder="Middle Name"
              onChange={(e) => setField("middleName", e.target.value)}
            />
          </div>
          <div className="col-md-4">
            <label htmlFor="lastName">Last Name</label>
            <input
              type="text"
              className="form-control"
              id="lastName"
              name="lastName"
              placeholder="Last Name"
              onChange={(e) => setField("lastName", e.target.value)}
            />
            {errors.lastName && (
              <span className="error">{errors.lastName}</span>
            )}
          </div>
        </div>
        <div className="form-row">
          <div className="col-md-6">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              className="form-control"
              id="email"
              name="email"
              placeholder="Email"
              value={form.email || ""}
              onChange={(e) => setField("email", e.target.value)}
              disabled={isEmailFromParams}
            />
            {errors.email && <span className="error">{errors.email}</span>}
          </div>
          <div className="col-md-6">
            <label htmlFor="phone">Phone Number</label>
            <input
              type="text"
              className="form-control"
              id="phone"
              name="phone"
              placeholder="Phone Number"
              onChange={(e) => setField("phone", e.target.value)}
            />
            {errors.phone && <span className="error">{errors.phone}</span>}
          </div>
        </div>
        <div className="form-row">
          <div className="col-md-6">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              className="form-control"
              id="password"
              name="password"
              placeholder="Password"
              onChange={(e) => setField("password", e.target.value)}
            />
            {errors.password && (
              <span className="error">{errors.password}</span>
            )}
          </div>
          <div className="col-md-6">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              type="password"
              className="form-control"
              id="confirmPassword"
              name="confirmPassword"
              placeholder="Confirm Password"
              onChange={(e) => setField("confirmPassword", e.target.value)}
            />
            {errors.confirmPassword && (
              <span className="error">{errors.confirmPassword}</span>
            )}
          </div>
        </div>
        <button type="submit" className="btn btn-primary mt-3" disabled={loading}>
          {loading ? "Creating Account..." : "Create Account"}
        </button>
      </form>
    </div>
  );
};

export default Register;
